import { writable } from "svelte/store";
import { service } from "./services";
import type { ApiResultOfListOfGroupLimitResponse, GroupLimitResponse, GroupLimits, GroupLimitDTO } from "./walletapi";
import { RegisterStartupCallback } from "./startup";

export const groupLimits = writable<GroupLimitResponse[]>([]);

export async function GroupLimitListStartup(firstStartup: boolean)
{
    RefreshGroupLimits();

    if (!firstStartup) return;

    service.walletapi.registerOperation("GroupLimitAdded", "GroupLimitAdded", GroupLimitAdded);
    service.walletapi.registerOperation("GroupLimitEdited", "GroupLimitEdited", GroupLimitEdited);
    service.walletapi.registerOperation("GroupLimitChanged", "GroupLimitChanged", GroupLimitChanged);
}

RegisterStartupCallback("GroupLimitListStartup", GroupLimitListStartup);

export async function RefreshGroupLimits() {
    try {
        console.log('🔄 Iniciando RefreshGroupLimits...');
        
        let response: ApiResultOfListOfGroupLimitResponse = await service.walletapi.groupLimitList({
            Token: sessionStorage.token,
        });

        console.log('📡 Respuesta completa del servidor:', response);
        console.log('✅ Success:', response.Success);
        console.log('📊 Data recibida:', response.Data);

        if (response.Success && response.Data) {
            // Procesar y convertir los datos para asegurar tipos correctos
            const processedGroupLimits: GroupLimitResponse[] = response.Data.map(groupLimit => ({
                ...groupLimit,
                Id: Number(groupLimit.Id),
                GroupId: groupLimit.GroupId !== null && groupLimit.GroupId !== undefined ? Number(groupLimit.GroupId) : undefined,
                UserId: groupLimit.UserId !== null && groupLimit.UserId !== undefined ? Number(groupLimit.UserId) : undefined
            }));

            // Log detallado de cada group limit procesado
            console.log('🔍 Analizando cada group limit procesado:');
            processedGroupLimits.forEach((groupLimit, index) => {
                console.log(`  GroupLimit ${index + 1}:`, {
                    Id: groupLimit.Id,
                    GroupId: groupLimit.GroupId,
                    UserId: groupLimit.UserId,
                    InitialBalance: groupLimit.InitialBalance,
                    Balance: groupLimit.Balance
                });
            });

            groupLimits.set(processedGroupLimits);
            console.log('✅ GroupLimits procesados y actualizados en el store');
        } else {
            console.error('❌ Error al obtener la lista de group limits:', response.ErrorMessage);
        }
    } catch (error) {
        console.error('💥 Error en la llamada a la API:', error);
    }
}

export function GroupLimitAdded(groupLimit: GroupLimits)
{   
    console.log("GroupLimitAdded", groupLimit);

    // Convertir GroupLimits a GroupLimitResponse para compatibilidad con el store
    const groupLimitResponse: GroupLimitResponse = {
        Id: groupLimit.Id,
        GroupId: groupLimit.GroupId,
        UserId: groupLimit.UserId,
        InitialBalance: groupLimit.InitialBalance,
        Balance: groupLimit.Balance,
        DateTransaction: groupLimit.DateTransaction,
        Active: groupLimit.Active
    };

    groupLimits.update(list => {
        list.unshift(groupLimitResponse);
        return list;
    });
};

export function GroupLimitEdited(groupLimit: GroupLimits)
{   
    console.log("GroupLimitEdited", groupLimit);

    // Convertir GroupLimits a GroupLimitResponse para compatibilidad con el store
    const groupLimitResponse: GroupLimitResponse = {
        Id: groupLimit.Id,
        GroupId: groupLimit.GroupId,
        UserId: groupLimit.UserId,
        InitialBalance: groupLimit.InitialBalance,
        Balance: groupLimit.Balance,
        DateTransaction: groupLimit.DateTransaction,
        Active: groupLimit.Active
    };

    groupLimits.update(list => {
        const index = list.findIndex(gl => gl.Id === groupLimit.Id);
        if (index !== -1) {
            // Actualizar el elemento existente
            list[index] = groupLimitResponse;
        } else {
            // Si no se encuentra, agregarlo al inicio
            list.unshift(groupLimitResponse);
        }
        return list;
    });
};

export function GroupLimitChanged(groupLimit: GroupLimitDTO)
{   
    console.log("GroupLimitChanged", groupLimit);

    // Convertir GroupLimitDTO a GroupLimitResponse para compatibilidad con el store
    const groupLimitResponse: GroupLimitResponse = {
        Id: groupLimit.Id,
        GroupId: groupLimit.GroupId,
        UserId: groupLimit.UserId,
        InitialBalance: groupLimit.InitialBalance,
        Balance: groupLimit.Balance,
        DateTransaction: groupLimit.DateTransaction,
        Active: groupLimit.Active
    };

    groupLimits.update(list => {
        const index = list.findIndex(gl => gl.Id === groupLimit.Id);
        if (index !== -1) {
            // Actualizar solo el estado Active
            list[index] = {
                ...list[index],
                Active: groupLimit.Active
            };
        }
        return list;
    });
};
